import { css } from 'styled-components';

import { Shadow, StyledBoxShadowFn } from './types';

export const boxShadow: StyledBoxShadowFn = (sh) => ({ theme }) =>
  css`
    box-shadow: ${theme.shadows[sh as Shadow] || sh};
  `;
